import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <Card className="w-full max-w-md border-slate-200 shadow-lg">
        <CardHeader>
          <CardTitle className="font-display">Parola Sıfırlama</CardTitle>
          <p className="text-sm text-slate-500">E-posta adresinize parola sıfırlama bağlantısı oluşturulur.</p>
        </CardHeader>
        <CardContent>
          {done ? (
            <div className="space-y-4" data-testid="forgot-done">
              <p className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg p-3">
                Bağlantı oluşturuldu. Test modunda e-posta gönderilmez; yönetici "Giden E-postalar (Test)" ekranından bağlantıyı görüntüleyebilir.
              </p>
              <Link to="/giris"><Button variant="outline" className="w-full">Girişe dön</Button></Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-1.5">
                <Label>E-posta</Label>
                <Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              {error && <p className="text-sm text-rose-600">{error}</p>}
              <Button type="submit" className="w-full bg-sky-600 hover:bg-sky-700" disabled={loading} data-testid="forgot-submit-button">
                {loading && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Bağlantı Oluştur
              </Button>
              <div className="text-center"><Link to="/giris" className="text-sm text-sky-600 hover:underline">Girişe dön</Link></div>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
